import BasicButton from "components/BasicInputs/BasicButton";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import { apiSetAlert } from "../../../../../api/appApi";
import { apiMoadianInvoce } from "../../../../../api/moaddian";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { useState } from "react";

export default function Step4() {
    const dispatch = useDispatch()
    const store = useSelector((state: any) => state);
    const token = store.businessReducer.business?.token;
    const [loading, setLoading] = useState(false)
    const data = useFormikContext<TaxClientSettingsData>();
    const dsc =
        "به سایت  مراجعه کرده و پس از ورود به کارپوشه خود از قسمت ورود به پرونده > عضویت > شناسه یکتا حافظه ی مالیاتی > روی دکمه دریافت شناسه یکتا حافظه مالیاتی کلیک کنید. سپس گزینه توسط مودی را انتخاب و در ادامه فرایند تکمیل فرم، فایل Public Key خود را بارگذاری نمایید. بعد از تایید نهایی، شناسه یکتا نمایش داده شده را از سامانه کپی و در اینجا بارگذاری کنید.";

    const saveTaxInfo = () => {
        setLoading(true)
        // @ts-ignore
        dispatch(apiMoadianInvoce({ callBack: apiCallback, params: { taxId: data.values.taxId, fiscalFolderId: data.values.fiscalFolderId } }))
    }

    const apiCallback = (res: { message: string }) => {
        setLoading(false)
        // @ts-ignore
        dispatch(apiSetAlert(res.message, 'success'))
    }

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                {/*<span className="text-lg text-slate-400">مرحله 4</span>*/}
                <span>اتصال کسب و کار شما به سامانه مودیان با موفقیت انجام شده است. جهت تست ارتباط با سامانه میتوانید از دکمه زیر استفاده کنید</span>
            </div>
            <div className="flex flex-col gap-6 mt-8">
                {/* ---------------------------------- FORM ---------------------------------- */}
                <div className="flex items-end justify-end gap-8">
                    <div className="flex items-center w-full gap-4">
                        <div className="w-full">
                            <BasicTextInput

                                label="شناسه پرونده مالیاتی"
                                val={data.values.fiscalFolderId}
                                onChange={(val) => data.setFieldValue("fiscalFolderId", val)}
                            />
                        </div>
                        <div className="w-full">
                            <BasicTextInput

                                label="شناسه حافظه ی مالیاتی"
                                val={data.values.taxId}
                                onChange={(val) => data.setFieldValue("taxId", val)}
                            />
                        </div>
                    </div>

                </div>


            </div>

            <div className="flex items-center justify-center">
                <BasicButton disabled={loading} variant="contained" className="px-10 mr-8" onClick={() => saveTaxInfo()}>
                    {loading && <CircularProgress />}
                    <span>ذخیره اطلاعات</span>
                </BasicButton>
            </div>
        </div>
    );
}
